import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  background-color: #282c34;
  padding: 20px;
  color: white;
  text-align: center;
`;

const Nav = styled.nav`
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-size: 18px;

  &:hover {
    text-decoration: underline;
  }
`;
const Header = () => {
    return (
        <HeaderContainer>
            <h1>Long Beach Prone Paddle Challenge</h1>
            <h3>Since 2023</h3>
            <Nav>
                <NavLink to="/">Home</NavLink>
                <NavLink to="/about">About</NavLink>
                <NavLink to="/gallery">Gallery</NavLink>
                <NavLink to="/donation">Donation</NavLink>
                <NavLink to="/contact">Contact</NavLink>
            </Nav>
        </HeaderContainer>
    )
}

export default Header